module.exports = __webpack_public_path__ + "media/src/assets/images/translate-1a063926d764700d863641c86bd88fac.png";